import { render, staticRenderFns } from "./NewChatContacts.vue?vue&type=template&id=470b7b90"
import script from "./NewChatContacts.vue?vue&type=script&lang=js"
export * from "./NewChatContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports